import { render, staticRenderFns } from "./PropertyDialog.vue?vue&type=template&id=029fef9a&"
import script from "./PropertyDialog.vue?vue&type=script&lang=js&"
export * from "./PropertyDialog.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('029fef9a')) {
      api.createRecord('029fef9a', component.options)
    } else {
      api.reload('029fef9a', component.options)
    }
    module.hot.accept("./PropertyDialog.vue?vue&type=template&id=029fef9a&", function () {
      api.rerender('029fef9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/workflow/components/propertySetting/PropertyDialog.vue"
export default component.exports